import defaultClient from '@/plugins/axios/defaultClient'

export default {
  getMyfinbizOrganizationsByHost(host) {
    return defaultClient.get(`/myfinbiz/organizations/?host=${encodeURIComponent(host)}`)
  },
  getMyfinbizOrganizationAgenciesByHost(host) {
    return defaultClient.get(`/myfinbiz/organization-agencies/?host=${encodeURIComponent(host)}`)
  },
  postMyfinbizOrganizationsAddCustomer(uuid) {
    return defaultClient.post(`/myfinbiz/organizations/${uuid}/add-customer/`)
  },
  getMyfinbizCustomerFeeSettingsCurrent() {
    return defaultClient.get(`/myfinbiz/customer-fee-settings/current/`)
  },
}
